import axiosInstance from './apiConfig';

export const getTenantBySubPropertyId = async (
  propertyId: string,
): Promise<any> => {
  try {
    const response = await axiosInstance.get(
      `/tenant/getBySubPropertyId?subPropertyId=${propertyId}`,
    );

    return response.data;
  } catch (error) {
    throw new Error(`fetch tenant failed: ${error}`);
  }
};

export const addTenant = async (data: any): Promise<any> => {
  try {
    const response = await axiosInstance.post('/tenant/createTenant', data);

    return response.data;
  } catch (error) {
    throw new Error(`add tenant failed: ${error}`);
  }
};

export const updateTenant = async (id: number, data: any): Promise<any> => {
  try {
    const response = await axiosInstance.put(`/tenant/update?id=${id}`, data);

    return response.data;
  } catch (error) {
    throw new Error(`update tenant failed: ${error}`);
  }
};

export const changeTenant = async (data: any): Promise<any> => {
  try {
    const response = await axiosInstance.put(`/tenant/changeTenant`, data);

    return response.data;
  } catch (error) {
    throw new Error(`change tenant failed: ${error}`);
  }
};

export const deleteTenant = async (id: string): Promise<any> => {
  // eslint-disable-next-line no-useless-catch
  try {
    const response = await axiosInstance.delete(`/tenant/delete?id=${id}`);
    return response.data;
  } catch (error) {
    throw new Error(`Delete tenant failed: ${error}`);
  }
};

// Disable (inactivate) tenant record
export const disableTenant = async (
  disabledBy: string,
  id: string,
): Promise<any> => {
  try {
    const res = await axiosInstance.put(
      `/tenant/disable?id=${id}&disabledBy=${disabledBy}`,
    );
    return res.data;
  } catch (error) {
    throw new Error(`Disable tenant failed: ${error}`);
  }
};

// Fetch disabled tenants for given property & sub-property
export const getDisabledTenants = async (
  subPropertyId: string,
): Promise<any> => {
  try {
    const res = await axiosInstance.get('/tenant/disabled', {
      params: { subPropertyId },
    });
    return res.data;
  } catch (error) {
    throw new Error(`fetch disabled tenants failed: ${error}`);
  }
};
